import "./styles.scss";

import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
import { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogTitle, DialogActions, DialogContent } from "@material-ui/core";

import api from "../../services/api";
import iconLinkSVG from "../../assets/images/icons/icon_link.svg";
import iconEditSVG from "../../assets/images/icons/icon_edit.svg";
import iconMetodologiaSVG from "../../assets/images/icons/icon_metodologia.svg";
import iconContentSVG from "../../assets/images/icons/icon_classratings_content.svg";

import {
  getNextClass,
  getMethodology,
  putMethodology,
  postMethodology,
  searchMethodology,
  getMethodologyLingo,
} from "../../store/middleware";
import WordTheDay from "./components/WordTheDay";
import RenderHtml from "./components/RenderHtml";
import Pagination from "../../components/Pagination";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import AcademicProgress from "./components/AcademicProgress";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import MethodologyLingoforme from "./components/MethodologyLingoforme";
import Placeholder from "../../components/Placeholder/PlaceholderByPage";
import { getContentLinkWithSequentialScheduleId } from "../../utils/utils";
import { endLoading, initLoading } from "../../store/slices/generics.slice";

const Content = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { user } = useSelector((state) => state.userReducer);
  const { plans } = useSelector((state) => state.studentReducer);
  const { allLingos, allClasses } = useSelector((state) => state.genericReducer);
  const { methodology, counterMethodology } = useSelector((state) => state.contentReducer);

  const [newPlans, setNewPlans] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [inputSeach, setInputSeach] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [lingoforme, setLingoforme] = useState(false);
  const [multiPlans, setMultiPlans] = useState(false);
  const [buttonNavBar, setButtonNavBar] = useState(1);
  const [languagesMulti, setLanguagesMulti] = useState([]);
  const [searchOptions, setSearchOptions] = useState("classTitle");
  const [buttonSelectNivel, setButtonSelectNivel] = useState("A0");
  const [openModalConfimSend, setOpenModalConfimSend] = useState(false);
  const [oldButtonSelectNivel, setOldButtonSelectNivel] = useState("A0");
  const [buttonSelectLanguage, setButtonSelectLanguage] = useState("EN");

  const [cycle, setCycle] = useState("");
  const [order, setOrder] = useState("");
  const [idForm, setIdForm] = useState("");
  const [content, setContent] = useState("");
  const [classType, setClassType] = useState("");
  const [arrayLang, setArrayLang] = useState("");
  const [cycleName, setCycleName] = useState("");
  const [classTitle, setClassTitle] = useState("");
  const [linkForStudent, setStudentLink] = useState("");
  const [linkForTeacher, setTeacherLink] = useState("");

  const isTeacher = user?.role === "teacher";
  const isStudent = user?.role === "student";
  const isCS = user?.role === "customerService";
  const isManager = user?.role === "companyManager";

  const currentSequentialScheduleId = allClasses[0]?.sequentialScheduleId;
  const customLang = plans && !plans[0]?.studentPlanLanguages[0].lingoLanguage.customLang;

  const languageLevelLimits = allLingos.find((item) => {
    const lang = { EN: "US", ES: "ES", FR: "FR", PT: "BR", "CS-US-IN": "CS-US-IN" };
    return item.flag === lang[buttonSelectLanguage];
  });

  const minLevelLanguage = languageLevelLimits?.minLevelId ?? 1;
  const maxLevelLanguage = languageLevelLimits?.maxLevelId ?? 7;

  const canViewLevel = (levelId) => isManager || isCS || (levelId >= minLevelLanguage && levelId <= maxLevelLanguage);

  const langFormatted = {
    FRENCH: "FR",
    ENGLISH: "EN",
    SPANISH: "ES",
    PORTUGUESE: "PT",
    INTERVIEW: "CS-US-IN",
  };

  const handleSelectNameNivel = {
    A0: t("NIVEL_A0"),
    A1: t("NIVEL_A1"),
    A2: t("NIVEL_A2"),
    B1: t("NIVEL_B1"),
    B2: t("NIVEL_B2"),
    C1: t("NIVEL_C1"),
    C2: t("NIVEL_C2"),
    DM: t("NIVEL_DM"),
  };

  const getDataContent = async (lang = "EN", level = "A0", page = 1) => {
    dispatch(getMethodology(lang, level, page));
  };

  const handleClickClose = () => setOpenModal(false);

  const handleClickOpen = () => {
    resetFormsModal();
    setOpenModal(true);
  };

  const resetFormsModal = () => {
    setCycle("");
    setOrder("");
    setIdForm("");
    setContent("");
    setClassType("");
    setCycleName("");
    setClassTitle("");
    setStudentLink("");
    setTeacherLink("");
  };

  const handleAddContent = () => {
    try {
      const body = {
        cycle,
        order,
        cycleName,
        classType,
        classTitle,
        linkForStudent,
        linkForTeacher,
        contentCode: content,
        level: buttonSelectNivel,
        language: buttonSelectLanguage,
      };

      if (idForm) {
        const data = { ...body, id: idForm };
        dispatch(putMethodology(data)).then(() => getDataContent(buttonSelectLanguage, buttonSelectNivel));
      } else {
        dispatch(postMethodology(body)).then(() => getDataContent(buttonSelectLanguage, buttonSelectNivel));
      }
    } catch (e) {
      console.log("Erro handleAddContent: ", e);
    } finally {
      resetFormsModal();
      setOpenModal(false);
    }
  };

  const handleEditContent = (item) => {
    setIdForm(item.id);
    setCycle(item.cycle);
    setOrder(item.order);
    setContent(item.contentCode);
    setClassType(item.classType);
    setCycleName(item.cycleName);
    setClassTitle(item.classTitle);
    setStudentLink(item.linkForStudent);
    setTeacherLink(item.linkForTeacher);
    setOpenModal(true);
  };

  const handlePagination = (page) => {
    if (page === pageNumber) return;
    setPageNumber(page);
    getDataContent(buttonSelectLanguage, buttonSelectNivel, page);
  };

  const handleSearch = () => {
    dispatch(searchMethodology(searchOptions, buttonSelectLanguage, inputSeach?.trim(), buttonSelectNivel));
  };

  const handleCounterInfo = (value) => {
    switch (value) {
      case "Total":
        return methodology?.others ? methodology?.others.totalResults : 0;
      case "Quiz":
        return counterMethodology?.classTypes?.find((item) => item.classType === "Quiz")
          ? counterMethodology?.classTypes?.find((item) => item.classType === "Quiz")?.count
          : 0;
      case "Cycles":
        return counterMethodology?.countCycle ? counterMethodology?.countCycle : 0;
      case "Test":
        return counterMethodology?.classTypes?.find((item) => item.classType === "Test")
          ? counterMethodology?.classTypes?.find((item) => item.classType === "Test")?.count
          : 0;
      case "Exercises":
        return counterMethodology?.classTypes?.find((item) => item.classType === "Exercises")
          ? counterMethodology?.classTypes?.find((item) => item.classType === "Exercises")?.count
          : 0;
      default:
        return 0;
    }
  };

  const handleOnclickOptions = (value, type) => {
    setPageNumber(1);

    if (type === "level") {
      setLingoforme(false);
      setButtonSelectNivel(value);
      setOldButtonSelectNivel(value);
      getDataContent(buttonSelectLanguage, value, 1);
    } else if (type === "lingo" && lingoforme) {
      setLingoforme((state) => !state);
      setButtonSelectNivel(oldButtonSelectNivel);
    } else if (type === "lingo" && !lingoforme) {
      setLingoforme((state) => !state);
      setButtonSelectNivel(value);
    } else {
      if (multiPlans) {
        let valueFormatted = value === "EN" ? "US" : value === "PT" ? "BR" : value;
        let level = arrayLang?.find((item) => item.flag === valueFormatted)?.level;

        if (level === "DM") level = "C2";

        setButtonSelectNivel(level !== undefined ? level : "A0");
        getDataContent(value, level !== undefined ? level : "A0", 1);
      }

      if (newPlans.length > 1 && !isTeacher) {
        let valueFormatted = value === "EN" ? "US" : value === "PT" ? "BR" : value;
        let level = arrayLang?.find((item) => item.flag === valueFormatted)?.level;

        if (level === "DM") level = "C2";

        setButtonSelectNivel(level !== undefined ? level : "A0");
        getDataContent(value, level !== undefined ? level : "A0", 1);
      }

      setButtonSelectLanguage(value);
      getDataContent(value, buttonSelectNivel, 1);
    }
  };

  useEffect(() => {
    dispatch(getMethodologyLingo());
    dispatch(getNextClass());

    if (isStudent) {
      const newPlan = plans?.flatMap((item) =>
        item.studentPlanLanguages.map((lang) => decryptIfEncrypted(lang.lingoLanguage?.language?.name).toUpperCase()),
      );

      const lang = langFormatted[newPlan[0]];
      let level = plans[0]?.student?.studentLevelGrades[0]?.level.level ?? "A0";

      setNewPlans(newPlan);

      if (plans[0]?.plan.multiLingo) {
        let newArrayLang = [];
        plans[0]?.studentPlanLanguages?.map((lang) =>
          plans[0].student?.studentLevelGrades.filter((grade) => {
            if (grade.lingoLanguageId === lang.lingoLanguageId)
              newArrayLang.push({ flag: lang.lingoLanguage.flag, level: grade.level.level });
          }),
        );

        level = newArrayLang?.find((item) => item.flag === "US")?.level;

        let languages = [];
        plans?.map((plan) => {
          plan?.studentPlanLanguages?.map((language) => {
            languages.push(language?.lingoLanguage);
          });
        });

        setMultiPlans(true);
        setArrayLang(newArrayLang);
        setButtonSelectNivel(level);
        setLanguagesMulti(languages);
        setButtonSelectLanguage("EN");
        getDataContent("EN", level);
      } else {
        if (newPlan.length > 1) {
          let newArrayLang = [];
          for (let i = 0; i < plans?.length; i++) {
            plans[i]?.studentPlanLanguages?.map((lang) =>
              plans[i].student?.studentLevelGrades.filter((grade) => {
                if (grade.lingoLanguageId === lang.lingoLanguageId)
                  newArrayLang.push({ flag: lang.lingoLanguage.flag, level: grade.level.level });
              }),
            );
          }

          setArrayLang(newArrayLang);
          if (newArrayLang?.find((item) => item.flag === "US")?.flag === "US") {
            setButtonSelectLanguage("EN");
            setButtonSelectNivel(newArrayLang?.find((item) => item.flag === "US")?.level);
            getDataContent("EN", newArrayLang?.find((item) => item.flag === "US")?.level);
          } else if (newArrayLang?.find((item) => item.flag === "BR")?.flag === "BR") {
            setButtonSelectLanguage("PT");
            setButtonSelectNivel(newArrayLang?.find((item) => item.flag === "BR")?.level);
            getDataContent("PT", newArrayLang?.find((item) => item.flag === "BR")?.level);
          } else {
            setButtonSelectLanguage("ES");
            setButtonSelectNivel(newArrayLang?.find((item) => item.flag === "ES")?.level);
            getDataContent("ES", newArrayLang?.find((item) => item.flag === "ES")?.level);
          }
        } else {
          if (level === "DM") level = "C2";
          setButtonSelectLanguage(lang);
          getDataContent(lang, level);
          setButtonSelectNivel(level);
        }
      }
    }

    if (isTeacher) {
      dispatch(initLoading());
      api
        .get(`teachermanagement/getbyuser/${user?.id}`)
        .then((res) => {
          const plans = res?.data?.result?.items[0]?.teachers[0]?.teacherLanguages
            .filter((teacherLanguage) => teacherLanguage.isNative)
            .map((teacherLanguageFilter) => decryptIfEncrypted(teacherLanguageFilter?.language?.name).toUpperCase());

          const lang = langFormatted[plans[0]];

          setNewPlans(plans);
          getDataContent(lang, "A0");
          setButtonSelectLanguage(lang);
        })
        .catch((err) => console.log("teachermanagement ", err))
        .finally(() => dispatch(endLoading()));
    }

    if (isManager || isCS) {
      getDataContent("EN", "A0");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header title={t("CONTENT")} t={t} icon={<img src={iconContentSVG} alt="Content Icon" />} typeIcon="custom" />

        <div className="content">
          <div className="navbar">
            <div className="button_select">
              <span onClick={() => setButtonNavBar(1)} className={buttonNavBar === 1 ? "active" : ""}>
                {t("METHODOLOGY")}
              </span>
              {(customLang || isManager) && (
                <span onClick={() => setButtonNavBar(2)} className={buttonNavBar === 2 ? "active" : ""}>
                  {t("WORDOFTHEDAY")}
                </span>
              )}
              {(customLang || isManager) && (
                <span onClick={() => setButtonNavBar(3)} className={buttonNavBar === 3 ? "active" : ""}>
                  {t("ACADEMIC_PROGRESS")}
                </span>
              )}
            </div>

            {buttonNavBar === 1 && (
              <div className={`seach ${lingoforme ? "hide" : ""}`}>
                <input className="input" value={inputSeach} onChange={(e) => setInputSeach(e.target.value)} />

                <select value={searchOptions} onChange={(e) => setSearchOptions(e.target.value)}>
                  <option value="content">{t("CONTENT")}</option>
                  <option value="cycle">{t("CYCLE")}</option>
                  <option value="classType">{t("CLASS_TYPE")}</option>
                  <option value="cycleName">{t("CYCLE_NAME")}</option>
                  <option value="classTitle">{t("CLASS_TITLE")}</option>
                </select>
                <button className="buttonSeach" onClick={handleSearch}>
                  {t("BTN_SEARCH")}
                </button>
              </div>
            )}
          </div>

          {buttonNavBar === 1 && (
            <Fragment>
              <div className="cardNivel">
                <div className="card">
                  <span className="title">
                    {t("METHODOLOGY")} <br /> Lingofor.me
                  </span>
                  <button
                    onClick={() => handleOnclickOptions("lingo", "lingo")}
                    className={`circle methodology ${buttonSelectNivel === "lingo" ? "active" : ""}`}
                  >
                    <img src={iconMetodologiaSVG} />
                  </button>
                </div>

                {!isStudent && (
                  <div className={"card"} style={buttonSelectNivel === "lingo" ? { opacity: 0.5 } : {}}>
                    <span className="titleDemoClass">
                      {t("DEMO_CLASS_CONTENT")} {t("DEMO_CLASS_CONTENT1")}
                    </span>

                    <div>
                      <button
                        onClick={() => handleOnclickOptions("demo", "level")}
                        className={`circle blue_300 ${buttonSelectNivel === "demo" ? "active" : ""}`}
                      >
                        D
                      </button>
                    </div>
                  </div>
                )}

                {(canViewLevel(1) || canViewLevel(2) || canViewLevel(3)) && (
                  <div className={"card"} style={buttonSelectNivel === "lingo" ? { opacity: 0.5 } : {}}>
                    <span className="title">{t("BASIC")}</span>
                    <div>
                      {canViewLevel(1) && (
                        <button
                          onClick={() => handleOnclickOptions("A0", "level")}
                          className={`circle green_100 ${buttonSelectNivel === "A0" ? "active" : ""}`}
                        >
                          A0
                        </button>
                      )}
                      {canViewLevel(2) && (
                        <button
                          onClick={() => handleOnclickOptions("A1", "level")}
                          className={`circle green_700 ${buttonSelectNivel === "A1" ? "active" : ""}`}
                        >
                          A1
                        </button>
                      )}
                      {canViewLevel(3) && (
                        <button
                          onClick={() => handleOnclickOptions("A2", "level")}
                          className={`circle green_400 ${buttonSelectNivel === "A2" ? "active" : ""}`}
                        >
                          A2
                        </button>
                      )}
                    </div>
                  </div>
                )}

                {(canViewLevel(4) || canViewLevel(5)) && (
                  <div className={"card"} style={buttonSelectNivel === "lingo" ? { opacity: 0.5 } : {}}>
                    <span className="title">{t(customLang ? "LINGO_INTER" : "INTERVIEW")}</span>
                    <div>
                      {canViewLevel(4) && (
                        <button
                          onClick={() => handleOnclickOptions("B1", "level")}
                          className={`circle yellow_100 ${buttonSelectNivel === "B1" ? "active" : ""}`}
                        >
                          B1
                        </button>
                      )}
                      {canViewLevel(5) && (
                        <button
                          onClick={() => handleOnclickOptions("B2", "level")}
                          className={`circle yellow_700 ${buttonSelectNivel === "B2" ? "active" : ""}`}
                        >
                          B2
                        </button>
                      )}
                    </div>
                  </div>
                )}

                {(canViewLevel(6) || canViewLevel(7)) && (
                  <div className={"card"} style={buttonSelectNivel === "lingo" ? { opacity: 0.5 } : {}}>
                    <span className="title">{t("LINGO_ADV")}</span>
                    <div>
                      {canViewLevel(6) && (
                        <button
                          onClick={() => handleOnclickOptions("C1", "level")}
                          className={`circle red_100 ${buttonSelectNivel === "C1" ? "active" : ""}`}
                        >
                          C1
                        </button>
                      )}
                      {canViewLevel(7) && (
                        <button
                          onClick={() => handleOnclickOptions("C2", "level")}
                          className={`circle red_500 ${buttonSelectNivel === "C2" ? "active" : ""}`}
                        >
                          C2
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className={`cardInfoNivel ${lingoforme ? "hide" : ""}`}>
                <div className="div nivel">
                  <label className="title">{t("LEVEL")}</label>
                  <div>
                    <span className="description gray_500">{buttonSelectNivel}</span>
                    <span className="subTitle">{handleSelectNameNivel[buttonSelectNivel]}</span>
                  </div>
                </div>
                {handleCounterInfo("Total") > 0 && (
                  <div className="div">
                    <label className="title">{t("TOTAL_CLASSES")}</label>
                    <span className="description">{handleCounterInfo("Total")}</span>
                  </div>
                )}
                {handleCounterInfo("Quiz") > 0 && (
                  <div className="div">
                    <label className="title">{t("TOTAL_QUIZZES")}</label>
                    <span className="description">{handleCounterInfo("Quiz")}</span>
                  </div>
                )}
                {handleCounterInfo("Cycles") > 0 && (
                  <div className="div">
                    <label className="title">{t("TOTAL_CYCLES")}</label>
                    <span className="description">{handleCounterInfo("Cycles")}</span>
                  </div>
                )}
                {handleCounterInfo("Test") > 0 && (
                  <div className="div">
                    <label className="title">{t("FINAL_TEST")}</label>
                    <span className="description">{handleCounterInfo("Test")}</span>
                  </div>
                )}
                {/* {handleCounterInfo("Test") > 0 && (
                  <div className="div">
                    <label className="title">{t("FINAL_TEST")}</label>
                    <span className="description">{handleCounterInfo("Test")}</span>
                  </div>
                )} */}
                {/* {handleCounterInfo("Exercises") > 0 && (
                  <div className="div">
                    <label className="title">{t("COMPLEMENTARY_EXERCISES")}</label>
                    <span className="description">{handleCounterInfo("Exercises")}</span>
                  </div>
                )} */}
              </div>

              <div className={`selectLanguage ${lingoforme ? "hide" : ""}`}>
                {(isManager || isCS) && (
                  <Fragment>
                    <div className="language">
                      {[...allLingos]
                        ?.filter((item) => item.active)
                        ?.sort((a, b) => a.id - b.id)
                        ?.map((item, index) => {
                          const flag = item.flag === "BR" ? "PT" : item.flag === "US" ? "EN" : item.flag;
                          return (
                            <div
                              key={index}
                              onClick={() => handleOnclickOptions(flag, "lang")}
                              className={buttonSelectLanguage === flag ? "active" : ""}
                            >
                              <FlagIcon size={35} code={item.customLang ? item.flag.split("-")[1] : item.flag} />
                              <span className="titleLanguage">{item.description}</span>
                            </div>
                          );
                        })}
                    </div>

                    {isManager && (
                      <button onClick={handleClickOpen} className="addContent">
                        {t("BTN_ADD")}
                      </button>
                    )}
                  </Fragment>
                )}

                {multiPlans && (
                  <div className="language">
                    {languagesMulti
                      .filter((item) => item.active)
                      .sort((a, b) => a.id - b.id)
                      .map((item, i) => {
                        let valueFormatted = item.flag === "US" ? "EN" : item.flag === "BR" ? "PT" : item.flag;

                        return (
                          <div
                            key={i}
                            onClick={() => handleOnclickOptions(valueFormatted, "lang")}
                            className={buttonSelectLanguage === valueFormatted ? "active" : ""}
                          >
                            <FlagIcon size={35} code={item.flag} />
                            <span className="titleLanguage">{t(item.description.toUpperCase())}</span>
                          </div>
                        );
                      })}
                  </div>
                )}

                {!multiPlans && (isStudent || isTeacher) && (
                  <div className="language">
                    {newPlans.includes("ENGLISH") && (
                      <div
                        onClick={() => handleOnclickOptions("EN", "lang")}
                        className={buttonSelectLanguage === "EN" ? "active" : ""}
                      >
                        <FlagIcon size={35} code={"US"} />
                        <span className="titleLanguage">{t("BTN_ENGLISH")}</span>
                      </div>
                    )}

                    {newPlans.includes("SPANISH") && (
                      <div
                        onClick={() => handleOnclickOptions("ES", "lang")}
                        className={buttonSelectLanguage === "ES" ? "active" : ""}
                      >
                        <FlagIcon size={35} code={"ES"} />
                        <span className="titleLanguage">{t("BTN_SPANISH")}</span>
                      </div>
                    )}

                    {newPlans.includes("PORTUGUESE") && (
                      <div
                        onClick={() => handleOnclickOptions("PT", "lang")}
                        className={buttonSelectLanguage === "PT" ? "active" : ""}
                      >
                        <FlagIcon size={35} code={"BR"} />
                        <span className="titleLanguage">{t("BTN_PORTUGUESE")}</span>
                      </div>
                    )}

                    {newPlans.includes("FRENCH") && (
                      <div
                        onClick={() => handleOnclickOptions("FR", "lang")}
                        className={buttonSelectLanguage === "FR" ? "active" : ""}
                      >
                        <FlagIcon size={35} code={"FR"} />
                        <span className="titleLanguage">{t("FRENCH")}</span>
                      </div>
                    )}
                    {newPlans.includes("INTERVIEW") && (
                      <div
                        onClick={() => handleOnclickOptions("CS-US-IN", "lang")}
                        className={buttonSelectLanguage === "CS-US-IN" ? "active" : ""}
                      >
                        <FlagIcon size={35} code={"US"} />
                        <span className="titleLanguage">{t("INTERVIEW")}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {lingoforme && (isStudent || isTeacher) && <RenderHtml customLang={customLang} />}

              {lingoforme && isManager && <MethodologyLingoforme setOpenModalConfimSend={setOpenModalConfimSend} />}

              {!lingoforme && (
                <div className="containerTable">
                  {(isManager || isCS) &&
                    (methodology?.items?.length > 0 ? (
                      <table>
                        <thead>
                          <tr>
                            <th className="p8">{t("ORDER")}</th>
                            <th>{t("CONTENT")}</th>
                            <th>{t("CYCLE")}</th>
                            <th>{t("CLASS_TYPE")}</th>
                            <th>{t("CLASS_TITLE")}</th>
                            <th>{t("CYCLE_NAME")}</th>
                            <th>{t("STUDENT_LINK")}</th>
                            <th>{t("TEACHER_LINK")}</th>
                            {isManager && <th className="p8">{t("OPTIONS")}</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {methodology?.items.map((item) => {
                            return (
                              <tr key={item.id}>
                                <td className="p8 center">{item.order}</td>
                                <td className="center">{item.contentCode}</td>
                                <td className="center">{item.cycle}</td>
                                <td className="center">{item.classType}</td>
                                <td className="center">{item.classTitle}</td>
                                <td className="center">{item.cycleName}</td>
                                <td className="center">
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    className="linkContent"
                                    href={getContentLinkWithSequentialScheduleId(
                                      item.linkForStudent,
                                      currentSequentialScheduleId,
                                    )}
                                  >
                                    <img src={iconLinkSVG} alt="link For Student" />
                                  </a>
                                </td>
                                <td className="center">
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    className="linkContent"
                                    href={getContentLinkWithSequentialScheduleId(
                                      item.linkForTeacher,
                                      currentSequentialScheduleId,
                                    )}
                                  >
                                    <img src={iconLinkSVG} alt="link For Student" />
                                  </a>
                                </td>
                                {isManager && (
                                  <td className="center">
                                    <div className="buttonTable">
                                      <button onClick={() => handleEditContent(item)}>
                                        <img src={iconEditSVG} alt="Edit Icon" />
                                      </button>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    ) : (
                      <div style={{ marginTop: 20 }}>
                        <Placeholder pageName="users" textMsg="Nothing here yet" />
                      </div>
                    ))}

                  {(isTeacher || isStudent) &&
                    (methodology?.items?.length > 0 ? (
                      <>
                        <table>
                          <thead>
                            <tr>
                              <th className="p8">{isTeacher ? t("CONTENT") + " - T" : t("CONTENT")}</th>
                              <th>{t("CYCLE")}</th>
                              <th>{t("CLASS_TYPE")}</th>
                              <th>{t("CLASS_TITLE")}</th>
                              <th>{t("CYCLE_NAME")}</th>
                              {isTeacher && <th>{t("CONTENT") + " - S"}</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {methodology?.items.map((item) => {
                              return (
                                <tr key={item.id}>
                                  <td className="p8 center" style={{ width: 150 }}>
                                    {isTeacher && (
                                      <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={getContentLinkWithSequentialScheduleId(
                                          item.linkForTeacher,
                                          currentSequentialScheduleId,
                                        )}
                                      >
                                        <button className="center buttonTeacher">{item.contentCode}</button>
                                      </a>
                                    )}
                                    {isStudent && (
                                      <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={getContentLinkWithSequentialScheduleId(
                                          item.linkForStudent,
                                          currentSequentialScheduleId,
                                        )}
                                      >
                                        <button className="center buttonStudent">{item.contentCode}</button>
                                      </a>
                                    )}
                                  </td>
                                  <td className="center" style={{ width: 80 }}>
                                    {item.cycle}
                                  </td>
                                  <td className="center">{item.classType}</td>
                                  <td className="center">{item.classTitle}</td>
                                  <td className="center">{item.cycleName}</td>
                                  {isTeacher && (
                                    <td style={{ width: 150 }} className="p8 center">
                                      <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={getContentLinkWithSequentialScheduleId(
                                          item.linkForStudent,
                                          currentSequentialScheduleId,
                                        )}
                                      >
                                        <button className="center buttonStudent">{item.contentCode}</button>
                                      </a>
                                    </td>
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>

                        {methodology?.items?.map((item) => (
                          <div key={item.id} className="tableResponsive">
                            <div>
                              <p className="title">{t("CONTENT")}</p>
                              {isTeacher && (
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  href={getContentLinkWithSequentialScheduleId(
                                    item.linkForTeacher,
                                    currentSequentialScheduleId,
                                  )}
                                >
                                  <button className="center buttonTeacher">{item.contentCode}</button>
                                </a>
                              )}
                              {isStudent && (
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  href={getContentLinkWithSequentialScheduleId(
                                    item.linkForStudent,
                                    currentSequentialScheduleId,
                                  )}
                                >
                                  <button className="center buttonStudent">{item.contentCode}</button>
                                </a>
                              )}
                            </div>
                            <div>
                              <p className="title">{t("CYCLE")}</p>
                              <p className="description">{item.cycle}</p>
                            </div>
                            <div>
                              <p className="title">{t("CLASS_TYPE")}</p>
                              <p className="description">{item.classType}</p>
                            </div>
                            <div>
                              <p className="title">{t("CLASS_TITLE")}</p>
                              <p className="description">{item.classTitle}</p>
                            </div>
                            <div>
                              <p className="title">{t("CYCLE_NAME")}</p>
                              <p className="description">{item.cycleName}</p>
                            </div>
                            {isTeacher && (
                              <div>
                                <p className="title">{t("contentCode")}</p>
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  href={getContentLinkWithSequentialScheduleId(
                                    item.linkForStudent,
                                    currentSequentialScheduleId,
                                  )}
                                >
                                  <button className="center buttonStudent">{item.contentCode}</button>
                                </a>
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    ) : (
                      <div style={{ marginTop: 20 }}>
                        <Placeholder pageName="users" textMsg="Nothing here yet" />
                      </div>
                    ))}

                  <Pagination
                    pageCurrent={methodology?.others?.pageNumber}
                    totalPages={methodology?.others?.totalPages}
                    totalFound={10}
                    totalResults={methodology?.others?.totalResults}
                    onClick={(page, type) => handlePagination(page, type)}
                  />
                </div>
              )}
            </Fragment>
          )}

          {buttonNavBar === 2 && <WordTheDay />}

          {buttonNavBar === 3 && <AcademicProgress />}
        </div>
      </section>

      <Dialog
        open={openModal}
        onClose={handleClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{!idForm ? t("NEW_CONTENT") : t("EDIT_CONTENT")}</span>
        </DialogTitle>
        <DialogContent>
          <div className="formModal">
            <div className="row">
              <div className="divInput" style={{ width: "17%" }}>
                <label className="labelModal">{t("ORDER")}</label>
                <input value={order} onChange={(e) => setOrder(e.target.value)} />
              </div>
              <div className="divInput" style={{ width: "17%" }}>
                <label className="labelModal">{t("CONTENT")}</label>
                <input value={content} onChange={(e) => setContent(e.target.value)} />
              </div>
              <div className="divInput" style={{ width: "17%" }}>
                <label className="labelModal">{t("CYCLE")}</label>
                <input value={cycle} onChange={(e) => setCycle(e.target.value)} />
              </div>
              <div className="divInput" style={{ width: "30%" }}>
                <label className="labelModal">{t("CLASS_TYPE")}</label>
                <input value={classType} onChange={(e) => setClassType(e.target.value)} />
              </div>
            </div>

            <div className="row">
              <div className="divInput" style={{ width: "41%" }}>
                <label className="labelModal">{t("CLASS_TITLE")}</label>
                <input value={classTitle} onChange={(e) => setClassTitle(e.target.value)} />
              </div>
              <div className="divInput" style={{ width: "53%" }}>
                <label className="labelModal">{t("CYCLE_NAME")}</label>
                <input value={cycleName} onChange={(e) => setCycleName(e.target.value)} />
              </div>
            </div>

            <div className="row">
              <div className="divInput" style={{ width: "41%" }}>
                <label className="labelModal">{t("STUDENT_LINK")}</label>
                <input value={linkForStudent} onChange={(e) => setStudentLink(e.target.value)} />
              </div>
              <div className="divInput" style={{ width: "53%" }}>
                <label className="labelModal">{t("TEACHER_LINK")}</label>
                <input value={linkForTeacher} onChange={(e) => setTeacherLink(e.target.value)} />
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            className="addContent"
            onClick={handleAddContent}
            style={{ marginBottom: 10, marginRight: 32, paddingLeft: 20, paddingRight: 20 }}
          >
            {!idForm ? t("BTN_ADD") : t("CHANGE")}
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openModalConfimSend}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setOpenModalConfimSend(false)}
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{t("TITLE_MODAL_SEND")}</span>
        </DialogTitle>
        <DialogContent>
          <div style={{ width: "100%" }}>
            <p style={{ textAlign: "center" }}>{t("DESCRIPTION_MODAL_SEND_METHOLOGY")}</p>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            type="submit"
            className="addContent"
            onClick={() => setOpenModalConfimSend(false)}
            style={{ marginBottom: 10, marginRight: 15, paddingLeft: 20, paddingRight: 20 }}
          >
            {t("BTN_CLOSE")}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Content;
